import { trackApplicationFiltersModalCleared } from '@store/application_filters';
import { useAppDispatch } from '@store/hooks';

export function useTrackFiltersCleared() {
  const dispatch = useAppDispatch();

  return () => dispatch(trackApplicationFiltersModalCleared());
}
